import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ResponseObject } from '../models/response-object.model';

@Injectable({
  providedIn: 'root'
})
export class AssociationPriceListWarehouseService {

  private URL = environment.api + "api/erp/association-price-list-warehouse";

  constructor(
    private http: HttpClient
  ) {}

  getAssociateCompanies(warehouseId: number): Observable<ResponseObject> {
    return this.http.get<ResponseObject>(`${this.URL}/warehouse/${warehouseId}`);
  }

  createRelationWarehousePriceList(warehouseId: number, priceListId: number): Observable<ResponseObject> {
    const params = new HttpParams()
      .set('warehouseId', warehouseId)
      .set('priceListId', priceListId);

    return this.http.post<ResponseObject>(`${this.URL}/create`, null, { params });
  }

  deleteRelationWarehousePriceList(warehouseId: number, priceListId: number): Observable<ResponseObject> {
    const params = new HttpParams()
      .set('warehouseId', warehouseId)
      .set('priceListId', priceListId);

    return this.http.delete<ResponseObject>(`${this.URL}/delete`, { params });
  }
}
